<app-dialog
    [visible]="showDialog()"
    [header]="'USER_PROFILE.DEAL_PREFERENCES_PROMPT.HEADER' | translate"
    [modal]="true"
    [closable]="true"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    [style]="{ width: '520px' }"
    (visibleChange)="onDialogVisibleChange($event)"
>    @if (promptQuestion(); as ref) {
        <div class="flex flex-col gap-5 mb-6">
            <p class="text-body-medium text-secondaryLabel m-0">
                {{ 'USER_PROFILE.DEAL_PREFERENCES_PROMPT.DESCRIPTION' | translate }}
            </p>

            @if (questionForm) {
                <form [formGroup]="questionForm" class="flex flex-col gap-4">
                    @if (showCategoryHeader()) {
                        <p
                            class="text-subheading-large font-bold text-[var(--brand-primary-dark)] bg-gray-50 rounded-lg px-3 py-2 m-0"
                        >
                            {{ ref.categoryIndex + 1 }}. {{ ref.category.description }}
                        </p>
                    }

                    <div formArrayName="questions" class="flex flex-col gap-5">
                        @for (qIdx of ref.displayQuestionIndices; track qIdx; let i = $index) {
                            @if (getQuestionAt(i); as question) {
                                @if (isQuestionVisible(i)) {
                                    <div class="flex flex-col gap-3 pl-1" [formGroupName]="i">
                                        <p class="text-label-medium-r text-bodyText m-0">
                                            {{ question.question }}
                                        </p>

                                        <div formArrayName="answers" class="flex flex-col gap-3">
                                            @if (question.answerType === AnswerType.checkbox) {
                                                @for (answer of question.answer; track answer.id; let answerIndex = $index) {
                                                    <div class="flex flex-col gap-2" [formGroupName]="answerIndex">
                                                        <div class="flex items-center">
                                                            <app-checkbox
                                                                formControlName="selected"
                                                                [inputId]="'prefPromptCheck' + i + '_' + answerIndex"
                                                                [binary]="true"
                                                            />
                                                            <label
                                                                [for]="'prefPromptCheck' + i + '_' + answerIndex"
                                                                class="text-label-medium-r text-bodyText ml-2 cursor-pointer"
                                                            >
                                                                {{ answer.answer }}
                                                            </label>
                                                        </div>
                                                        @if (
                                                            isOtherAnswer(answer.answer) &&
                                                            getQuestionAnswers(i).at(answerIndex).get('selected')?.value
                                                        ) {
                                                            <app-input
                                                                type="text"
                                                                formControlName="answerText"
                                                                [fluid]="true"
                                                                [placeholder]="
                                                                    'USER_PROFILE.DEAL_PREFERENCES_PROMPT.OTHER_PLACEHOLDER'
                                                                        | translate
                                                                "
                                                                (onInput)="onTextInput($event, i, answerIndex)"
                                                            />
                                                        }
                                                    </div>
                                                }
                                            } @else if (question.answerType === AnswerType.radio_button) {
                                                @for (answer of question.answer; track answer.id; let answerIndex = $index) {
                                                    <div class="flex items-center" [formGroupName]="answerIndex">
                                                        <p-radioButton
                                                            formControlName="selected"
                                                            [value]="true"
                                                            [inputId]="'prefPromptRadio' + i + '_' + answerIndex"
                                                            [name]="'prefPromptQuestion' + i"
                                                            (onClick)="onRadioSelect(i, answerIndex)"
                                                        />
                                                        <label
                                                            [for]="'prefPromptRadio' + i + '_' + answerIndex"
                                                            class="text-label-medium-r text-bodyText ml-2 cursor-pointer"
                                                        >
                                                            {{ answer.answer }}
                                                        </label>
                                                    </div>
                                                }
                                            } @else if (question.answerType === AnswerType.textbox) {
                                                <div [formGroupName]="0">
                                                    <app-input
                                                        type="text"
                                                        formControlName="answerText"
                                                        [fluid]="true"
                                                        [placeholder]="
                                                            'USER_PROFILE.DEAL_PREFERENCES_PROMPT.OTHER_PLACEHOLDER'
                                                                | translate
                                                        "
                                                        (onInput)="onTextInput($event, i, 0)"
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            }
                        }
                    </div>
                </form>
            }
        </div>
    }

    <div class="flex gap-3">
        <app-button
            [label]="'USER_PROFILE.DEAL_PREFERENCES_PROMPT.SKIP' | translate"
            variant="secondary"
            [fluid]="true"
            class="basis-1/2"
            [disabled]="saving()"
            (onClick)="onSkip()"
        />
        <app-button
            [label]="'USER_PROFILE.DEAL_PREFERENCES_PROMPT.SAVE' | translate"
            variant="primary"
            [fluid]="true"
            class="basis-1/2"
            [loading]="saving()"
            (onClick)="onSave()"
        />
    </div>
</app-dialog>
